import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';

let Observable = new Subject();

window._rx = {
	_eventList: {},
	on(eventName, handle) {
		if (!this._eventList[eventName]) {
			this._eventList[eventName] = {};
		}
		let fns = this._eventList[eventName];
		if (!fns[handle]) {
			// 订阅以后返回一个对象，即 Subscription (订阅)
			fns[handle] = Observable.pipe(
				filter((event) => {
					return event.name == eventName;
				})
			).subscribe((value) => {
				handle(...value.payload);
			});
		}
		return this;
	},
	/**
	 *
	 * @param {String} eventName
	 * @param {Function} handle
	 * 如果没有提供参数，则移除所有的事件监听器；
	 * 如果只提供了事件，则移除该事件所有的监听器；
	 * 如果同时提供了事件与回调，则只移除这个回调的监听器。
	 */
	off(eventName, handle) {
		if (eventName) {
			let fns = this._eventList[eventName];
			if (fns) {
				if (handle) {
					if (fns[handle]) {
						fns[handle].unsubscribe();
						delete fns[handle];
					}
				} else {
					for (const key in fns) {
						if (Object.hasOwnProperty.call(fns, key)) {
							fns[key].unsubscribe();
						}
					}
					this._eventList[eventName] = {};
				}
			}
		} else {
			for (const eventName in this._eventList) {
				if (Object.hasOwnProperty.call(this._eventList, eventName)) {
					const fns = this._eventList[eventName];
					for (const key in fns) {
						if (Object.hasOwnProperty.call(fns, key)) {
							fns[key].unsubscribe();
						}
					}
				}
			}
			this._eventList = {};
		}
		return this;
	},
	emit(eventName, ...arg) {
		Observable.next({
			name: eventName,
			payload: arg,
		});
		return this;
	},
};
